<script lang="ts" setup>
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'
import { usePrepareDetailsCarData } from '@autobid/ui/composables/car/usePrepareDetailsCarData'
import { computed } from 'vue'

interface Props {
  details: DetailsCarItemDetails
}

const props = defineProps<Props>()
const { imagePanelInstrument } = usePrepareDetailsCarData(
  computed(() => props.details),
)
</script>

<template>
  <tr v-if="imagePanelInstrument.display">
    <td>
      <table class="w-full border-collapse">
        <thead>
          <SectionsDetailsPdfElementsHeading colspan="2" as="th">
            {{ imagePanelInstrument.title }}
          </SectionsDetailsPdfElementsHeading>
        </thead>
        <tbody>
          <SectionsDetailsPdfElementsList
            v-if="imagePanelInstrument.displayList"
            :elements="details.imagePanelInstrument.list"
            :in-two-cols-from="imagePanelInstrument.twoColumnsFrom"
          />

          <tr>
            <td colspan="2">
              <SectionsDetailsPdfElementsImages
                v-if="imagePanelInstrument.displayImages"
                :images="details.imagePanelInstrument.images"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>
